import { type Lens } from '@dhmk/zustand-lens';

import type { Catalog } from '../models/issues/issue';

export type CatalogStatus = 'idle' | 'loading' | 'refreshing';

type State = {
  catalog?: Catalog;
  hasCatalogError: boolean;
  catalogStatus: CatalogStatus;
  retryCount: number;
};

type Actions = {
  setCatalogStatus: (status: CatalogStatus) => void;
  retryCatalog: () => void;
  catalogFetchSucceeded: (catalog: Catalog) => void;
  catalogFetchFailed: () => void;
};

export type CatalogSlice = State & Actions;

type Slice = { catalog: CatalogSlice };

export class CatalogStore {
  createSlice = (initialState: Partial<State> = {}) => {
    const state: Lens<CatalogSlice> = (set) => ({
      catalog: undefined,
      hasCatalogError: false,
      catalogStatus: 'loading',
      retryCount: 0,
      ...initialState,
      setCatalogStatus: (catalogStatus) => set({ catalogStatus }),
      retryCatalog: () => set((prev) => ({ retryCount: prev.retryCount + 1 })),
      catalogFetchSucceeded: (catalog) =>
        set({ catalog, hasCatalogError: false, catalogStatus: 'idle' }),
      catalogFetchFailed: () =>
        set({ hasCatalogError: true, catalogStatus: 'idle' }),
    });
    return state;
  };

  partialize = ({ catalog }: Slice) => ({
    catalog: catalog.catalog,
  });
}

export const selectCatalog = ({ catalog }: Slice) => ({
  catalog: catalog.catalog,
  catalogStatus: catalog.catalogStatus,
});
